<template>
  <div class="card">
    <b-loading :is-full-page="false" v-model="isLoading" :can-cancel="true"></b-loading>

    <div class="card-content">
      <div>
        <b-field style="padding-bottom:0px; margin-bottom:0px;">
          <header class="card-header">
            <h1 id="editHeader" class="card-header-title">
              Add New Coupon
            </h1>

          </header>
        </b-field>

        <section class="modal-card-body">
          <b-field label="Code">
            <b-input type="text" placeholder="Code" v-model="formModel.code" :disabled="action == 'UPDATE'" required>
            </b-input>
          </b-field>

          <b-field label="Amount Type">
            <b-select placeholder="Click to select..." v-model="formModel.amountType">
              <option v-for="(option, index) in amountTypeOptions" :value="option.value" :key="index">
                {{ option.name }}
              </option>
            </b-select>
          </b-field>

          <b-field label="Amount Value">
            <b-input type="number" placeholder="Amount Value" v-model="formModel.amount" required>
            </b-input>
          </b-field>

          <b-field label="Start Date">
            <b-input type="date" v-model="formModel.startDate" placeholder="Start Date" required>
            </b-input>
          </b-field>

          <b-field label="End Date">
            <b-input type="date" placeholder="End Date" v-model="formModel.endDate">
            </b-input>
          </b-field>
        </section>

        <footer class="modal-card-foot">
          <b-button type="is-primary" @click="handleAction()"> {{ actionButtonLabel }} </b-button>
          <b-button type="is-danger" label="Close" @click="closeModal()" />
        </footer>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import moment from 'moment';
import { mapActions } from 'vuex';
export default Vue.extend({
  props: {
    action: {
      type: String,
      required: true
    },
    payload: {
      type: Object,
      required: false
    }
  },
  data() {
    return {
      formModel: {
        code: "",
        amount: 0,
        amountType: "fixed",
        startDate: null,
        endDate: null
      },
      amountTypeOptions: [
        { name: "Fixed", value: "fixed" },
        { name: "Percent", value: "percent" },
      ],
      isLoading: false
    }
  },
  computed: {
    actionButtonLabel() {
      return this.action == 'CREATE' ? 'Add Coupon' : 'Update Coupon'
    }
  },
  mounted() {
    if (this.action == 'UPDATE') {
      this.formModel.code = this.payload.code;
      this.formModel.amount = this.payload.amount;
      this.formModel.amountType = this.payload.amountType;
      this.formModel.endDate = moment(this.payload.endDate).format("YYYY-MM-DD");
      this.formModel.startDate = moment(this.payload.startDate).format("YYYY-MM-DD");
    }
  },
  methods: {
    ...mapActions({
      createCoupon: "couponStore/createCoupon",
      updateCoupon: "couponStore/updateCoupon"
    }),
    handleAction() {
      if (this.action == 'CREATE') this.addCoupon();
      else if (this.action == 'UPDATE') this.editCoupon();
    },
    async addCoupon() {
      this.isLoading = true;
      if (this.formModel.amountType == 'fixed') {
        if (this.formModel.amount > 0) {
          let res = await this.createCoupon(this.formModel);

          if (res == 409) {
            this.$buefy.toast.open({
              message: "Coupon Code already in use",
              type: "is-danger",
              duration: 2500
            });
          } else {
            this.closeModal();
          }
        } else {
          this.$buefy.toast.open({
            message: "Amount value must be greater than 0",
            type: "is-danger",
            duration: 2500
          });
        }
        this.isLoading = false;
      }

      if (this.formModel.amountType == 'percent') {
        if (this.formModel.amount > 0 && this.formModel.amount <= 100) {
          let res = await this.createCoupon(this.formModel);
          if (res == 409) {
            this.$buefy.toast.open({
              message: "Coupon Code already in use",
              type: "is-danger",
              duration: 2500
            });
          }
          else {
            this.closeModal();
          }
        }
        else {
          this.$buefy.toast.open({
            message: "Amount value must be greater than 0% and less than or equal to 100%",
            type: "is-danger",
            duration: 2500
          });
        }
        this.isLoading = false;
      }
    },
    async editCoupon() {
      const updatedCoupon = {
        ...this.payload,
        ...this.formModel
      }

      this.isLoading = true;


      if (this.formModel.amountType == 'fixed') {
        if (this.formModel.amount > 0) {
          await this.updateCoupon(updatedCoupon);
          this.closeModal();
        }
        else {
          this.$buefy.toast.open({
            message: "Amount value must be greater than 0",
            type: "is-danger",
            duration: 2500
          });

        }
        this.isLoading = false;
      }

      if (this.formModel.amountType == 'percent') {
        if (this.formModel.amount > 0 && this.formModel.amount <= 100) {
          await this.updateCoupon(updatedCoupon);
          this.closeModal();
        }
        else {
          this.$buefy.toast.open({
            message: "Amount value must be greater than 0% and less than or equal to 100%",
            type: "is-danger",
            duration: 2500
          });
        }
        this.isLoading = false;
      }
    },
    closeModal() {
      this.$parent.close()
    }
  }
})
</script>

<style lang="scss">
// #editModal{
//  height: 40.8rem !important; 
// }
// .modal-container {
//   padding-bottom: 2rem;
//   .card-header{
//     box-shadow: none;  
//   }

//   .modal-card-body{
//     input,select{
//         border : 1px solid #E6E6E6;
//     }
//   }

//   .modal-card-foot{
//     background-color: transparent;
//     border: none; 
//     display: flex;
//     gap: 0.5rem;
//     padding-bottom:  2.6rem;
//   }
// }
</style>